// config
// mission
// startValue

G.PFEventPanelMission = function(config) {
  this.goalObj = config.mission;

  config.valueTarget = config.mission.getCurrentVal();
  config.value = config.startValue === undefined ? config.valueTarget : config.valueTarget;
  config.target = config.mission.getTarget();
  config.progressBar = {};

  G.PFEventPanel.call(this, config);

  this.desc = this.add(new G.Text(0, -20, config.mission.getDescription(), {
    style: "font-white",
    fontSize: 25,
  }, 0.5, 300));

  if (this.goalObj.icon) {
    this.icon = G.makeImage(-180, 4, this.goalObj.icon, [0, 0.5], this);
    this.icon.width = this.icon.height = 50;
    this.icon.scale.setTo(Math.min(this.icon.scale.x, this.icon.scale.y));
  }
};

G.PFEventPanelMission.prototype = Object.create(G.PFEventPanel.prototype);